<template>
  <div class="app-navbar-actions">
    <VaIconMenuCollapsed
      class="cursor-pointer justify-start"
      :class="{ 'x-flip': !isSidebarMinimized }"
      :color="collapseIconColor"
      @click="isSidebarMinimized = !isSidebarMinimized"
    />
    <ProfileDropdown class="app-navbar-actions__item app-navbar-actions__item--profile mr-1">
      <span>{{ userName }}</span>
    </ProfileDropdown>
  </div>
</template>

<script lang="ts" setup>
import ProfileDropdown from './dropdowns/ProfileDropdown.vue'
import VaIconMenuCollapsed from '../../icons/VaIconMenuCollapsed.vue'
import { useGlobalStore } from '../../../stores/global-store'
import { useColors } from 'vuestic-ui'
import { storeToRefs } from 'pinia'
import { computed } from 'vue'
const { isSidebarMinimized } = storeToRefs(useGlobalStore())
defineProps({
  isMobile: { type: Boolean, default: false },
  userName: { type: String, default: false },
})

import { useI18n } from 'vue-i18n'
const { t } = useI18n()
const { getColor } = useColors()

const collapseIconColor = computed(() => getColor('secondary'))
</script>

<style lang="scss">
.app-navbar-actions {
  display: flex;
  align-items: center;

  .va-dropdown__anchor {
    color: var(--va-primary);
    fill: var(--va-primary);
  }

  &__item {
    padding: 0;
    margin-left: 0.25rem;
    margin-right: 0.25rem;

    svg {
      height: 20px;
    }

    &--profile {
      display: flex;
      justify-content: center;
    }

    .va-dropdown-content {
      background-color: var(--va-white);
    }

    @media screen and (max-width: 640px) {
      margin-left: 0;
      margin-right: 0;

      &:first-of-type {
        margin-left: 0;
      }
    }
  }

  .fa-github {
    color: var(--va-on-background-primary);
  }
}
</style>
